import { capitalizeFirstLetter, handleInputChange } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: $ and jQuery are loaded globally, not via imports

class PayoutScheduleModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      payoutInterval: this.props.payoutInterval,
      timeFrame: this.props.timeFrame,
    }
    this.save = this.save.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleIntervalChange = this.handleIntervalChange.bind(this)
    this.validator = validatorFactory()
  }

  payoutScheduleOptions() {
    const options = ["weekly", "monthly"]
    // only dockwa employees can set daily option or if it is already set to daily
    if (this.props.dockwaEmployee || this.props.payoutInterval === "daily") {
      options.unshift("daily")
    }
    return options
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleIntervalChange(event) {
    this.setState({
      payoutInterval: event.target.value,
      timeFrame: this.timeFrameFromSchedule(event.target.value)[0],
    })
  }

  closeModal() {
    this.setState({
      showModal: false,
      payoutInterval: this.props.payoutInterval,
      timeFrame: this.props.timeFrame,
    })
  }

  openModal() {
    this.setState({ showModal: true })
  }

  save() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({
        saving: true,
        validationErrorMessage: null,
      })
      const params = {
        _method: "patch",
        payout_interval: this.state.payoutInterval,
        time_frame: this.state.timeFrame,
      }
      $.post(this.props.route, params, () => {
        location.reload()
      }).fail(() => {
        this.setState({
          saving: false,
          validationErrorMessage:
            "Something went wrong changing the payout schedule on your account.",
        })
      })
    } else {
      this.forceUpdate()
    }
  }

  timeFrameFromSchedule(schedule) {
    if (schedule === "weekly") {
      return [
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
        "monday",
        "tuesday",
      ]
    } else if (schedule === "monthly") {
      return _.range(1, 32)
    } else {
      return []
    }
  }

  timeFrameSelect() {
    const timeFrame = this.timeFrameFromSchedule(this.state.payoutInterval)
    if (timeFrame.length) {
      return (
        <div className="form-group">
          <label>
            {this.state.payoutInterval === "weekly"
              ? "Day of Week"
              : "Day of Month"}
          </label>
          <select
            className="form-control"
            name="timeFrame"
            value={this.state.timeFrame}
            onChange={this.handleInputChange}
          >
            {_.map(timeFrame, (time) => (
              <option key={time} value={time}>
                {isNaN(time) ? capitalizeFirstLetter(time) : time}
              </option>
            ))}
          </select>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <a
          className="text-link-blue cursor-pointer"
          href="#"
          onClick={this.openModal}
        >
          Edit
        </a>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="small"
        >
          <Modal.Header
            title="Update Payout Schedule"
            subtext="The payout schedule is when money is transferred to your bank."
          />
          <Modal.Body>
            <div className="form-group">
              <label>Payout Interval</label>
              <select
                className="form-control"
                name="payoutInterval"
                value={this.state.payoutInterval}
                onChange={this.handleIntervalChange}
              >
                {_.map(this.payoutScheduleOptions(), (schedule) => (
                  <option key={schedule} value={schedule}>
                    {capitalizeFirstLetter(schedule)}
                  </option>
                ))}
              </select>
            </div>
            {this.timeFrameSelect()}
            {this.validator.messageWhenPresent(
              this.state.validationErrorMessage
            )}
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Update Schedule"
            onClose={this.closeModal}
            onSubmit={this.save}
            confirmBtnLoading={this.state.saving}
          />
        </Modal>
      </div>
    )
  }
}

PayoutScheduleModal.propTypes = {
  payoutInterval: PropTypes.string.isRequired,
  timeFrame: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  route: PropTypes.string.isRequired,
  dockwaEmployee: PropTypes.bool,
}

export default PayoutScheduleModal
